import { useCallback, useEffect, useRef } from "react"
import { useLocation, useMatches, useParams } from "react-router"

import { IS_DEV } from "@/lib/constants"

import { useLogPageViewMutation } from "../graphql/public-generated-rq"

const shouldLogPageViews = !IS_DEV

export function PageViewLogger() {
  const referrer = useRef<string>(window.document.referrer)
  const { mutate } = useLogPageViewMutation()
  const location = useLocation()
  const params = useParams()
  const matches = useMatches()

  const logPageViewToApi = useCallback(() => {
    mutate({
      input: {
        url: window.location.href,
        route: matches.at(-1)?.id ?? location.pathname,
        pathname: location.pathname,
        routeParams: params,
        title: window.document.title,
        referrer: referrer.current,
      },
    })
    referrer.current = `${window.location.origin}${location.pathname}${location.search}`
  }, [location, matches, mutate, params])

  useEffect(() => {
    if (!shouldLogPageViews) return
    logPageViewToApi()
  }, [location, logPageViewToApi])

  return null
}
